<template>
  <div :class="{'names-section-collapsed': !toggle}" ref="namesSelection">
    <div class="names-header">
      <span
        @click="resizeToggleContacts"
        class="ns-toggle-contacts"
      >
        <img class="menu-icon" src="@/assets/images/arrow_left.png" alt="menu-left" v-show="!toggle">
        <img class="menu-icon" src="@/assets/images/arrow_right.png" alt="menu-right" v-show="toggle" style="opacity: 0.5">
      </span>
    </div>
    <div class="names-content">
      <div
        v-for="person in conversationsList"
        :key="person.conversationGuid"
        class="chat-thumb"
        @click="loadConversation(person)"
        :class="{'selected-element': person.conversationGuid === currentConversation.conversationGuid}"
      >
        <div class="ct-avatar" :style="{ backgroundColor: person.color }">
          {{ person.nameInitials }}
        </div>
        <div class="ct-content" :class="{'ct-content-show': toggle}">
          <div class="ct-contet-top">
            <div class="ct-name">
              <span>{{ person.firstName }}</span>
              <span>{{ person.lastName }}</span>
            </div>
            <div class="ct-time">{{ person.lastMessageTime }}</div>
          </div>
          <div class="ct-contet-bottom">
            <div class="ct-text">{{ person.lastMessagePreview }}</div>
            <div class="ct-badge" v-if="person.unreadMessageCount > 0">{{ person.unreadMessageCount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { GET_CLICKED_ON_CONTACT } from "@/store/action.types";

  export default {
    data() {
      return {
        toggle: true,
        isMobile: false,
        conversationsList: []
      }
    },
    props: {
      currentConversation: {
        type: Object,
        required: true,
        default: () => {}
      },
      detectMobile: {
        type: Boolean,
        required: true,
        default: () => false,
      }
    },
    mounted() {
      this.conversationsList = this.$store.getters.getConversationsList;
      this.$root.$on('conversations', this.conversationsUpdated);
      window.addEventListener('orientationchange', this.resizeToggleContacts);
      this.isMobile = this.detectMobile;
      if (this.isMobile) {
        if (this.toggle) {
          this.$refs.namesSelection.style.flex = '1 0 100%';
        } else {
          this.$refs.namesSelection.style.flex = '0 0 0';
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('orientationchange', this.resizeToggleContacts);
    },
    methods: {
      ...mapActions({
        GET_CLICKED_ON_CONTACT
      }),
      conversationsUpdated(conversations) {
        this.conversationsList = conversations;
        this.$forceUpdate();
      },
      resizeToggleContacts() {
        // Disable contact toggle for mobile devices portrait and remove collapsed class
        if (!this.isMobile) {
          this.toggle = !this.toggle;
        } else {
          this.toggle = !this.toggle;
          if (this.toggle) {
            this.$refs.namesSelection.style.flex = '1 0 100%';
          }
          else {
            this.$refs.namesSelection.style.flex = '0 0 0';
          }
        }
      },
      // When user clicks on contact, there are two possible events
      // Creating conversation if there is no conversationGuid
      // Loading initial messages if conversation has guid
      loadConversation(person) {
        if (person.conversationGuid !== null) {
          this.$emit('loadConversation', person);
        } else {
          this.$emit('createConversation', person)
        }

        if (this.isMobile) {
          this.toggle = false;
          this.$refs.namesSelection.style.flex = '0 0 0';
        }

        this.$store.dispatch('GET_CLICKED_ON_CONTACT', true);
      }
    }
  }
</script>
